import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

export default function CloudStorage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <VuiBox p={4}>
                <VuiTypography variant="h3" color="white" fontWeight="bold" mb={1}>
                  Cloud Storage
                </VuiTypography>
                <VuiTypography variant="button" color="text" fontWeight="regular">
                  Blank starter page for building your cloud services website.
                </VuiTypography>
              </VuiBox>
            </Card>
          </Grid>
        </Grid>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}
